module.exports = "../static/media/search-empty.1716e9a1.png";